import { useSite } from "@/context/SiteContext";
import { useSeo } from "@/components/site/Seo";
import { PageBand } from "@/components/site/PageBand";

export default function Questionnaire() {
  const { content } = useSite();
  const q = content.questionnaire;
  useSeo("questionnaire");
  return (
    <div data-testid="questionnaire-page">
      <PageBand title={q.title} id="questionnaire" />
      <section className="px-2 sm:px-6 py-10 flex justify-center">
        <iframe
          title={q.title}
          src={q.url}
          width={q.width}
          height={q.height}
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          style={{ maxWidth: "100%" }}
          data-testid="questionnaire-iframe"
        >
          Loading…
        </iframe>
      </section>
    </div>
  );
}
